import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Auth.css';

const HomeIcon = ({active}) => (
  <svg width="20" height="20" fill="none" stroke={active ? "#0090d0" : "#0074a6"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
    <path d="M4 12L12 5l8 7" />
    <rect x="6" y="12" width="12" height="7" rx="2" />
    <rect x="10" y="15" width="4" height="4" rx="1" />
  </svg>
);
const SearchIcon = ({active}) => (
  <svg width="24" height="24" fill="none" stroke={active ? "#0090d0" : "#0074a6"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>
);
const BookingIcon = ({active}) => (
  <svg width="24" height="24" fill="none" stroke={active ? "#0090d0" : "#0074a6"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="4"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
);
const ProfileIcon = ({active}) => (
  <svg width="24" height="24" fill="none" stroke={active ? "#0090d0" : "#0074a6"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-2.21 3.58-4 8-4s8 1.79 8 4"/></svg>
);

const BottomNav = () => {
  const location = useLocation();
  const path = location.pathname;
  return (
    <nav className="bottom-nav">
      <Link to="/home" className={"nav-icon" + (path === "/home" ? " active" : "") }><HomeIcon active={path === "/home"} /><div>Home</div></Link>
      <Link to="/search" className={"nav-icon" + (path === "/search" ? " active" : "") }><SearchIcon active={path === "/search"} /><div>Search</div></Link>
      <Link to="/booking" className={"nav-icon" + (path === "/booking" ? " active" : "") }><BookingIcon active={path === "/booking"} /><div>Booking</div></Link>
      <Link to="/my-profile" className={"nav-icon" + (path === "/my-profile" ? " active" : "") }><ProfileIcon active={path === "/my-profile"} /><div>Me</div></Link>
    </nav>
  );
};

export default BottomNav; 